const {store} = aofljs;
import mutations from './mutations';

const NAMESPACE = 'testimonialsPopup';
const ALIAS = 'testimonialsPopup';

let sdo = {
  namespace: NAMESPACE,
  alias: ALIAS,
  mutations: mutations
};

store.addState(sdo);



// WEBPACK FOOTER //
// ./home/en-US/js/testimonials-popup/sdo/index.js